export default "__VITE_ASSET__DH22W1zN__"